import { StandardError } from "@core-ts/StandardError"

import axios from "axios"
import { ModificationResult, ModifyRequest, ResultRow, QueryRequest, QueryResponse, ResultHeader, StorageServiceClient, QueryVResponse, ModifyVResponse, QueryVRequest, HeaderCallback, ResultCallbackMultiple, ModifyVRequestClassless, ModifyRequestClassless, ResultRowVariantClassless } from "@core-ts/clients/StorageServiceClient"
import { getServicePath } from "./Frontend"
import { convertResultRowVariantToResultRowVariantClassless } from "@core-ts/Variant"
import { context } from "@core-ts/Contexts/Context"

// This file must be compatible with a browser

export class StorageServiceClientWeb extends StorageServiceClient {

    async QueryV(requests: QueryRequest[], rowCallbacks: ResultCallbackMultiple[], metaCallbacks: HeaderCallback[]): Promise<void> {

        if (requests.length !== rowCallbacks.length || requests.length !== metaCallbacks.length)
            throw new StandardError("queryRequests, rowCallbacks and metaCallbacks must have the same length")
        

        const queryVResponse = (await context.request.cache.get(
            requests.map((request) => `${request.queryString}:${request.requestedFields.join("/")}`).join("//"),
            async () => {
                const request: QueryVRequest = { requests }
                const rawResponse = await axios.post(getServicePath('storage') + 'QueryV', request)

                if ("responseContext" in rawResponse.data) {
                    // TODO: Proper parsing
                    if ("error" in rawResponse.data.responseContext && "customErrorMessage" in rawResponse.data.responseContext.error) {
                        throw new StandardError("Error during QueryV call: " + rawResponse.data.responseContext.error.customErrorMessage)
                    }
                }

                if ("result" in rawResponse.data) {
                    return rawResponse.data["result"] as unknown as QueryVResponse
                }

                throw new StandardError("Error during QueryV call, unparsable response")
            },
        )) as QueryVResponse
        let atResponse: number | null = 0

        for (const queryResponse of queryVResponse.responses) {
            // This doesn't actually check that response was reasonable but this on the client side. The server is assumed to be trusted
            if (metaCallbacks)
                await metaCallbacks[atResponse](queryResponse.meta)

            await rowCallbacks[atResponse](queryResponse.meta, queryResponse.rows)

            atResponse++
        }
    }
    async ModifyV(requests: ModifyRequest[]): Promise<ModificationResult[]> {
        const classlessRequests: ModifyRequestClassless[] = []

        for (const request of requests) {
            const classlessModificationRows: ResultRowVariantClassless[] = []
            for (const modificationRow of request.modificationRows ?? []) {
                classlessModificationRows.push(convertResultRowVariantToResultRowVariantClassless(modificationRow))
            }
            classlessRequests.push({
                method: request.method,
                selectorString: request.selectorString,
                modificationRows: classlessModificationRows
            })
        }

        const request: ModifyVRequestClassless = {
            requests: classlessRequests
        }


        const rawResponse = await axios.post(getServicePath('storage') + 'ModifyV', request)

        // This doesn't actually check that response was reasonable but this on the client side. The server is assumed to be trusted
        const modifyResponse = rawResponse.data as unknown as ModifyVResponse

        return modifyResponse.responses
    }


    async connect(host: string): Promise<void> {
    }

    /*    async QueryUntyped(queryRequest: QueryRequest,  rowCallback: (resultMeta: ResultMeta, row: ResultRowNative) => void, metaCallback?: (meta: ResultMeta) => void): Promise<void> {
    
            console.log("making request")
    
            const rawResponse = await axios({
                method: "post",
                url: getServicePath("storage") + "Query",
                data: queryRequest,
                validateStatus: () => {
                    return true
                }
            })
    
            if (rawResponse.status.toString()[0] !== "2") {
                throw new StandardError(rawResponse.data)
            }
    
            // const rawResponse = await axios.post(getServicePath('storage') + 'Query', queryRequest)
            
            // This doesn't actually check that response was reasonable but this on the client side. The server is assumed to be trusted
            const queryResponse = rawResponse.data as unknown as QueryResponse
            if(metaCallback)
            metaCallback(queryResponse.meta)
            
            for(let row of queryResponse.rows) {
                rowCallback(queryResponse.meta, row)
            }
            
        }
    */
    // Note, QueryUntypedGetAll() only exists on StorageServiceClientWeb because internal services and gateways are not allowed to assume that the requested data is 
    // small enough to fit in memory. But since we will never send more than a few megabytes of data to the web client, the web client code is 
    // allowed to assume that it can fit the entire response in memory
    async QueryUntypedGetAll(queryRequest: QueryRequest, openSnackbar?: (text: string, severity: "success" | "error") => void): Promise<QueryResponse | undefined> {
//        return await context.request.cache.getCached(JSON.stringify(queryRequest),
//            async () => {
                const rows: ResultRow[] = []
                let rowCount = 0
                let meta: ResultHeader | null = null

                try {


                    await this.QueryUntypedCallback(queryRequest,
                        async (meta: ResultHeader, row: ResultRow) => {
                            rows.push(row)
                            rowCount++
                            if (rowCount > 100)
                                throw new StandardError("At most 100 rows can be fetched through QueryUntypedGetAll. For more, processing should be moved to server-side")
                        },
                        async m => {
                            meta = m
                        }
                    )
                    if (meta === null)
                        throw new StandardError("Never received meta data from Query")

                    return { meta, rows }
                } catch (error: unknown) {
                    if (error instanceof Error && openSnackbar) {
                        openSnackbar(error.message, "error")

                        return
                    }

                    throw error
                }
            }
//        )
//    }
}

export function getStorageServiceClientWeb(storageClient: StorageServiceClient): StorageServiceClientWeb {
    if(storageClient instanceof StorageServiceClientWeb)
        return storageClient
    throw new StandardError("StorageServiceClientWeb is not available in this context")
}